module.exports = __webpack_public_path__ + "static/media/golfer-4-a.31bca833.png";